import letter from './../assets/Letter.png'
import cart from './../assets/Shopping-Cart.png'
import share from './../assets/Share.svg';
import info from './../assets/Info.svg';
import { useEffect, useRef, useState } from 'react';
import { getTranslations } from '../utils/translations';
import { stripHtml } from '../utils/htmlUtils';

function FullSermonView({ playlist, message }) {
    const t = getTranslations();
    console.log('Rendering FullSermonView with ', message);
    const playlistItem = message;
    const fullMessageUrl = message?.messagePermalink;

    let path = '';
    if (playlistItem?.seriesPage) {
        try {
            const url = new URL(playlistItem.seriesPage);
            path = url.pathname;
        } catch (error) {
            console.error('Invalid URL:', playlistItem.seriesPage, error);
            path = '';
        }
    }

    const [copyStatus, setCopyStatus] = useState('');
    const [showShareTutorial, setShowShareTutorial] = useState(false);
    const tutorialRef = useRef(null);

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            setCopyStatus(t.copied);
        } catch (err) {
            setCopyStatus(t.copyFailed);
            console.error('Error copying URL:', err);
        } finally {
            // Clear the status message after a few seconds
            setTimeout(() => setCopyStatus(''), 3000);
        }
    };

    const handleTutorialClick = () => {
        setShowShareTutorial(true);
    };

    const closeTutorial = () => {
        setShowShareTutorial(false);
    };

    // Close tutorial when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tutorialRef.current && !tutorialRef.current.contains(event.target)) {
                setShowShareTutorial(false);
            }
        };

        if (showShareTutorial) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [showShareTutorial]);

    return (
        <div id="full-sermon-view" style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', color: 'var(--vpv-text-color, #fff)' }}>
            <div className="content" style={{ paddingLeft: 0, paddingBottom: 0 }}>
                <div id="featured-buttons" className="options" style={{ display: 'flex', width: '100%', justifyContent: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    {playlistItem?.notes && playlistItem.notes.includes('http') && (
                        <a
                            id="cphPlayer_C001_LibraryDetail_Resources_lnkMessageMate"
                            className="btn-new"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={t.downloadBibleStudy}
                            data-original-title={t.downloadBibleStudy}
                            href={playlistItem?.notes}
                            target="_blank"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '111px', '--vpv-btn-text-color': '#35467f' }}
                            rel="noreferrer">
                            <img src={letter} style={{ width: '13px', height: '15px', marginRight: '10px' }} alt="logo" />{t.bibleStudy}
                        </a>
                    )}
                    {playlistItem?.message && playlistItem.message.includes('http') && (
                        <a
                            id="cphPlayer_C001_LibraryDetail_Resources_lnkBuyMessage"
                            className="btn-new"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={message?.mediaType === 'video' ? t.buyVideo : t.buyMessage}
                            data-original-title={message?.mediaType === 'video' ? t.buyVideo : t.buyMessage}
                            href={playlistItem?.message}
                            target="_blank"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '111px', '--vpv-btn-text-color': '#35467f' }}
                            rel="noreferrer">
                            <img src={cart} style={{ width: '16px', height: '15px', marginRight: '10px' }} alt="logo" />{message?.mediaType === 'video' ? t.video : t.message}
                        </a>
                    )}
                    {playlistItem?.series && playlistItem.series.includes('http') && (
                        <a
                            id="cphPlayer_C001_LibraryDetail_Resources_lnkBuySeries"
                            className="btn-new"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={message?.messageSpeaker === 'Paws & Tales' ? t.buySeason : (message?.mediaType === 'video' ? t.buyVideoSeries : t.buySeries)}
                            data-original-title={message?.messageSpeaker === 'Paws & Tales' ? t.buySeason : (message?.mediaType === 'video' ? t.buyVideoSeries : t.buySeries)}
                            href={playlistItem?.series}
                            target="_blank"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '111px', '--vpv-btn-text-color': '#35467f' }}
                            rel="noreferrer">
                            <img src={cart} style={{ width: '16px', height: '15px', marginRight: '10px' }} alt="logo" />{message?.messageSpeaker === 'Paws & Tales' ? t.fullSeason : t.fullSeries}
                        </a>
                    )}
                    <button
                        className="btn-new"
                        data-toggle="tooltip"
                        data-placement="top"
                        title={t.shareThisSermon}
                        onClick={handleCopyClick}
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '111px', '--vpv-btn-text-color': '#35467f', cursor: 'pointer', border: 'none' }}
                    >
                        <img src={share} style={{ width: '16px', height: '15px', marginRight: '10px', filter: 'brightness(0) saturate(100%) invert(26%) sepia(34%) saturate(1450%) hue-rotate(193%) brightness(95%) contrast(88%)' }} alt="share" />{t.share}
                    </button>
                </div>
                {copyStatus && <p style={{ fontSize: '12px', textAlign: 'center', marginTop: '10px', margin: '10px 0 0 0' }}>{copyStatus}</p>}
            </div>
            <div id="share-message" style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                marginTop: '10px',
                color: message?.playerType === 'single' ? '#000' : 'inherit'
            }}>
                <a href={fullMessageUrl} title={message?.messageSpeaker === 'Paws & Tales' ? t.visitEpisodePage : (message?.mediaType === 'video' ? t.viewFullVideo : t.viewFullMessage)} rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    {message?.playerType === 'single' ? <h2 style={{ marginBottom: '10px 0px' }}>{stripHtml(message?.name)}</h2> : <h1>{stripHtml(message?.name)}</h1>}
                </a>
                {window.location.href.includes('broadcasts/series-library/message') && (
                    <div style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span
                                title={t.howToShare}
                                onClick={handleTutorialClick}
                                style={{
                                    cursor: 'pointer',
                                    marginLeft: '8px',
                                    fontSize: '16px',
                                    opacity: '0.8'
                                }}
                            >
                                <img src={info} style={{
                                    width: '32px'
                                }} alt="info" />
                            </span>
                        </div>
                        {showShareTutorial && (
                            <div
                                ref={tutorialRef}
                                style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: '0',
                                    backgroundColor: '#fff',
                                    color: '#333',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    padding: '16px',
                                    width: '280px',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                    zIndex: '1000',
                                    fontSize: '14px',
                                    lineHeight: '1.4'
                                }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '12px'
                                }}>
                                    <h4 style={{ margin: 0, color: '#212E60', fontSize: '16px' }}>{t.howToShare}</h4>
                                    <span
                                        onClick={closeTutorial}
                                        style={{
                                            cursor: 'pointer',
                                            fontSize: '18px',
                                            color: '#999'
                                        }}
                                    >
                                        ×
                                    </span>
                                </div>
                                <ol style={{ margin: '0', paddingLeft: '18px' }}>
                                    <li style={{ marginBottom: '8px' }}>
                                        {t.shareStep1.replace('{type}', message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase())}
                                    </li>
                                    <li style={{ marginBottom: '8px' }}>
                                        {t.shareStep2}
                                    </li>
                                    <li style={{ marginBottom: '0' }}>
                                        {t.shareStep3
                                            .replace('{action}', message?.mediaType === 'video' ? t.watch : t.listen)
                                            .replace('{type}', message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase())}
                                    </li>
                                </ol>
                                <div style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    marginTop: '12px',
                                    fontSize: '12px',
                                    color: '#666'
                                }}>
                                    {t.shareTip
                                        .replace('{itemType}', message?.messageSpeaker === 'Paws & Tales' ? (message?.seriesName === 'Original Song' ? t.song.toLowerCase() : t.episode.toLowerCase()) : (message?.mediaType === 'video' ? t.video.toLowerCase() : t.message.toLowerCase()))
                                        .replace('{containerType}', message?.messageSpeaker === 'Paws & Tales' ? t.fullSeason.toLowerCase() : t.series.toLowerCase())}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div style={{ clear: 'left', color: message?.playerType === 'single' ? '#000' : 'inherit' }}>
                <div>{message?.messageSpeaker === 'Paws & Tales' ? t.fullSeason : t.fullSeries}: <a href={message?.seriesPage} title={message?.messageSpeaker === 'Paws & Tales' ? t.viewFullSeason : t.viewFullSeries} rel="noreferrer" style={{ color: message?.playerType === 'single' ? '#000' : 'inherit' }}>{stripHtml(message?.seriesName)}</a></div>
                <span>
                    {message?.messageSpeaker === 'Paws & Tales'
                        ? (message?.seriesName === 'Original Song' ? t.song : t.episode)
                        : (message?.mediaType === 'video' ? t.video : t.message)
                    } {message?.messageNumber}
                </span>
                {' '}- {message?.messageSpeaker}
                {message?.scriptureReference && (
                    <div>{t.scriptureReference}: {message.scriptureReference}</div>
                )}
            </div>
        </div>
    );
}
export default FullSermonView;